<template>
  <div class="text-xs-center">
    <v-dialog
      v-model="show"
      width="40%"
    >
      <v-card>
        <v-card-title
          class="headline pb-1"
          primary-title
        >
          <div 
            v-show="hasError"
          >
            {{ dialogTitle }}
          </div>
        </v-card-title>

        <v-card-text class="pt-0">
          <v-progress-linear 
            :indeterminate="true" 
            v-show="isLoading"
          ></v-progress-linear>
          
          <ul>
            <li v-for="error in errors">
              {{ getErrorMessage(error) }}
            </li>
          </ul>
          
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions 
          v-show="hasError"
        >
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="closeDialog()"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>
export default {
  name: 'file-import-status-dialog',
  data () {
    return {
    }
  },

  props: {
    show: Boolean,
    isLoading: Boolean,
    errors: Array
  },

  methods: {
    closeDialog() {
      this.$emit('close-dialog')
    },
    getErrorMessage(error){
      if(!error){
        return "?"
      }
      switch(error.errType){
        case "fieldIsNaN":
          return "Cell " + (error.col ? String.fromCharCode(64 + error.col) : "?") + (error.row || "?") + " contains an invalid value: " + error.cellVal
        case "noGeocodeParam":
        case "failedGeocode":
          return "The site, \"" + (error.marketName || "?") + "\", does not have a valid address or latitude and longitude. "
        case "noResults":
          return "The import was unsuccessful, please check your format."
        case "invalidFile":
          return "Unable to import with the given file. Please check that the correct Excel file was selected, and try again."
        default:
          return "?"
      }
    }
  },

  computed: {
    dialogTitle(){
      return "Error Importing"
    },
    hasError() {
      return !this.isLoading && this.errors && this.errors.length
    }
  },

  watch: {
    isLoading() {
      if(!this.isLoading){
        if(!this.errors || !this.errors.length){
          this.closeDialog()
        }
      }
    }
  }
}

</script>

<style scoped>

</style>